import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const listAllocations = (customerId) =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId}/allocation/for-web`,
    axiosHeaderV2()
  );
